export const massCommunication = {
  navBar_sections_massCommunication: 'Communication en masse',
  mass_communication_creation_success: 'Communication en masse créée avec succès',
  mass_communication_creation_error: 'Erreur de création de communication en masse',
};
